module.exports = __webpack_public_path__ + "static/img/btn1_hover.df1c0d57.png";